import { 
  Pipe, 
  PipeTransform 
} from '@angular/core';  
import {TranslationService} from './services/translation.service';

@Pipe ({ 
  name: 'translate' 
}) 

export class TranslatePipe implements PipeTransform { 
  constructor(public service: TranslationService) {
       
  }
  transform(value: string): string { 
     return this.service.instant(value);
  } 
} 


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/translate.pipe.ts